export function getDifferenceInDays(dateIn: string): number {
  const now = new Date();
  const dayOne = new Date(dateIn);
  const diffMS = now.getTime() - dayOne.getTime();
  const minutes = Math.floor(diffMS / 60000);
  const hours = Math.round(minutes / 60);
  const dayNum = Math.round(hours / 24);
  return dayNum;
}

export function checkIsSameDay(
  dateString1: string,
  dateString2?: string
): boolean {
  const d1Date = new Date(dateString1);
  const d2Date = dateString2 ? new Date(dateString2) : new Date();
  return d1Date === d2Date;
}
